import type { Token } from '../model';
import { store } from './factory';
import * as Storage_ from './storage';
import type { Draft } from './types';

export import Storage = Storage_;

/**
 * React hook that returns the current authentication token.
 *
 * @returns Authentication token or `undefined` if no authentication token has been set.
 */
export const useToken = (): Token | undefined => store((state) => state.token);

/**
 * Non-reactive method that returns the authentication token from the store.
 *
 * @returns The authentication token or `undefined` if a token has not been set.
 */
export const getToken = (): Token | undefined => store.getState().token;

/**
 * Sets the specified token in both the store and in local storage.
 *
 * @param tokens - Map of authentication tokens
 * @param tokens.token - Authentication token or `undefined` to unset the existing token.
 * @param tokens.webplayerToken - Webplayer authentication token or `undefined` to unset the existing token.
 * @param options - Options
 */
export const setTokens = (tokens: { token: Token | undefined; webplayerToken: string | undefined } | undefined, options?: Storage.Options): void => {
  Storage.setToken(Storage.Tokens.COMMAND_CENTER_KEY, tokens?.token, options);
  Storage.setToken(Storage.Tokens.WEBPLAYER_KEY, tokens?.webplayerToken, options);

  // Update the store
  store.produce((draft: Draft) => {
    draft.token = tokens?.token;
    draft.webplayerToken = tokens?.webplayerToken;
    draft.me = undefined; // Will get reinitialized by the store reactions
  });
};
